module.exports = __webpack_public_path__ + "img/Ofertas.5f237010.png";